import { estabelecimento } from '../../Estabelecimento/estabelecimento'
import { createMessageBox, getUrlAction, newPage, sentryError, storage } from '../../utils'
import { mensagemFidelidade, store, showButtonOrder, storeOrder } from '../../mobile'
import { usuario } from '../../usuario'
import { toast, toastFideliza } from '../../components/message'

export const programaDeFidelidade = () => {
  //Se estiver logado busca os dados do programa de fidelidade
  if (usuario && usuario.id) {
    $.ajax({
      type: 'GET',
      url: getUrlAction('Cadastros', 'GetDadosProgramaFidelidade'),
      data: { urlEmpresa: estabelecimento.urlEmpresa },
      success: function (response, status, xhr) {
        estabelecimento.programaFidelidade = JSON.parse(response)
        estabelecimento.programaFidelidade.cliente = {
          pontos: estabelecimento.programaFidelidade.pontosAtuaisFideliza,
          pontosUtilizados: estabelecimento.programaFidelidade.pontosUtilizadosFideliza
        }
        const beneficios = estabelecimento.programaFidelidade?.beneficios;
        const cliente = estabelecimento.programaFidelidade?.cliente;

        let beneficiosProd = [];

        if (beneficios && beneficios.length > 0) {
          const beneficiosMap = new Map();
          beneficios.forEach(beneficio => {
            if (!beneficiosMap.has(beneficio.Produto)) {
              beneficiosMap.set(beneficio.Produto, []);
            }
            beneficiosMap.get(beneficio.Produto).push(beneficio);
          });

          store.produtos.forEach(produto => {
            const beneficiosDoProduto = beneficiosMap.get(produto.IdProd);
            if (beneficiosDoProduto) {
              beneficiosProd.push(...beneficiosDoProduto);
            }
          });
        }

        if (beneficiosProd && beneficiosProd.length > 0) {
          const itemMaisProximo = beneficiosProd.sort((a, b) => a.Pontos - b.Pontos);
          var faltamParaProximo = (itemMaisProximo[0] && itemMaisProximo[0]?.Pontos - (cliente?.pontos ?? 0) < 0) ? 0 : (itemMaisProximo[0] ? (itemMaisProximo[0]?.Pontos - (cliente?.pontos ?? 0)) : 0);
        }

        const clientePrimeiroPedido = cliente.pontosUtilizados == 0 && cliente.pontos == 0;

        newPage({
          id: 'programa-de-fidelidade',
          appbarTitle: 'Programa de Fidelidade',
          body: `
            <div class="title">Troque seus pontos por benefícios!</div>
            <div class="gap-4 resumo-cliente u-flex-column u-flex-start">
              <div class="font-14 font-500 resumo-cliente-item u-flex-center gap-4 cliente">
                <div class="resumo-cliente-item-descricao u-flex-center gap-4 u-flex-center gap-4">
                  <div class="svg-icon">
                    <svg width="17" height="17" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 4C8.5 4.66304 8.2366 5.29892 7.76777 5.76776C7.29893 6.23661 6.66304 6.5 6 6.5C5.33696 6.5 4.70108 6.23661 4.23224 5.76776C3.76339 5.29892 3.5 4.66304 3.5 4C3.5 3.33696 3.76339 2.70107 4.23224 2.23223C4.70108 1.76339 5.33696 1.5 6 1.5C6.66304 1.5 7.29893 1.76339 7.76777 2.23223C8.2366 2.70107 8.5 3.33696 8.5 4ZM8.561 7.073C9.1923 6.54664 9.6461 5.83858 9.8608 5.04514C10.0754 4.25169 10.0403 3.4114 9.7604 2.63858C9.4805 1.86576 8.9693 1.19793 8.2964 0.725938C7.62345 0.253958 6.82145 0.000747681 5.9995 0.000747681C5.17755 0.000747681 4.37555 0.253958 3.70262 0.725938C3.02969 1.19793 2.51849 1.86576 2.23859 2.63858C1.95868 3.4114 1.92364 4.25169 2.13825 5.04514C2.35286 5.83858 2.80669 6.54664 3.438 7.073C2.45359 7.5384 1.61427 8.26275 1.0099 9.1685C0.40553 10.0743 0.05886 11.1273 0.007 12.215C0.00218 12.411 0.0742801 12.6011 0.20788 12.7445C0.34147 12.888 0.52593 12.9735 0.72177 12.9826C0.9176 12.9918 1.10923 12.9239 1.25562 12.7935C1.40201 12.6631 1.49153 12.4806 1.505 12.285C1.55952 11.1295 2.0569 10.0394 2.89391 9.241C3.73091 8.44253 4.84324 7.99707 6 7.99707C7.15676 7.99707 8.2691 8.44253 9.1061 9.241C9.9431 10.0394 10.4405 11.1295 10.495 12.285C10.4975 12.3849 10.5198 12.4832 10.5608 12.5743C10.6018 12.6654 10.6606 12.7474 10.7337 12.8154C10.8068 12.8835 10.8928 12.9363 10.9865 12.9707C11.0803 13.0051 11.18 13.0204 11.2798 13.0157C11.3796 13.0111 11.4774 12.9865 11.5676 12.9435C11.6577 12.9005 11.7384 12.84 11.8048 12.7654C11.8713 12.6908 11.9221 12.6037 11.9544 12.5092C11.9868 12.4147 11.9999 12.3146 11.993 12.215C11.941 11.1272 11.5942 10.0741 10.9897 9.1683C10.3851 8.26255 9.5456 7.53826 8.561 7.073Z" fill="#00d26e"></path>
                    </svg>
                  </div>
                  <span>Cliente:</span>
                </div>
                <span id="valor">${usuario.nome ?? 'Não informado'}</span>
              </div>
              <div class="font-14 font-500 gap-4 resumo-cliente-item u-flex-center pontos">
                <div class="resumo-cliente-item-descricao u-flex-center gap-4">
                  <div class="svg-icon">
                    <svg width="18" height="18" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.49789 14.5001C9.33044 14.5001 11.4971 12.5193 11.4971 10C11.4971 8.50943 10.7947 7.78771 9.55693 6.55451C8.53872 5.54008 7.27583 4.26633 6.74902 2.14559C6.46086 2.37499 6.17936 2.66031 5.9531 2.99475C5.46604 3.71469 5.24058 4.63293 5.83879 5.82933C6.31231 6.77636 6.50841 8.11293 5.56066 9.06068C4.99612 9.62522 4.03042 10.0225 2.98238 9.58341C2.51163 9.38618 2.12204 9.05722 1.79773 8.64532C1.61652 9.02494 1.50001 9.48834 1.5 10.0001C1.49994 12.5298 3.6636 14.5001 6.49789 14.5001ZM8.01433 0.499817C7.99819 0.224147 7.77398 0.00218037 7.50695 0.0725374C5.79801 0.522811 2.7625 3.03092 4.49715 6.50016C4.84142 7.18868 4.78164 7.71838 4.5 8.00002C4.03859 8.46144 3.15137 8.49704 2.4261 6.72386C2.31949 6.46323 2.02626 6.31678 1.78436 6.46093C0.682776 7.11735 3.46795e-05 8.53551 1.7298e-09 10C-8.31534e-05 13.5121 2.99789 16.0001 6.49789 16.0001C9.99788 16.0001 12.9971 13.5 12.9971 10C12.9971 7.8628 11.8699 6.74063 10.6862 5.56221C9.45553 4.33695 8.16373 3.05088 8.01433 0.499817Z" fill="#ffa44e" style=""></path>
                    </svg>
                  </div>
                  <span>Pontos disponíveis:</span>
                </div>
                <span id="valor">${cliente.pontos ?? 0}</span>
              </div>
              ${faltamParaProximo == 0 ? '' :
              `
                <div class="font-14 font-500 gap-4 resumo-cliente-item u-flex-center faltam">
                  <div class="resumo-cliente-item-descricao u-flex-center gap-4">
                    <div class="svg-icon">
                      <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.064 0C11.7434 9.77766e-05 9.51786 0.922034 7.87699 2.563L7.41799 3.021C7.10399 3.335 6.80199 3.662 6.51399 4H3.30999C3.01117 4.00009 2.71736 4.07669 2.45653 4.2225C2.19571 4.36832 1.97657 4.57849 1.81999 4.833L0.10999 7.607C0.0499638 7.7045 0.0130574 7.81445 0.00209983 7.92842C-0.00885773 8.04239 0.00642442 8.15736 0.0467749 8.26451C0.0871255 8.37166 0.151473 8.46815 0.234886 8.54658C0.318298 8.62502 0.418561 8.68331 0.52799 8.717L3.62999 9.671C3.66699 9.722 3.70899 9.771 3.75399 9.816L6.18299 12.244C6.22899 12.29 6.27699 12.332 6.32799 12.369L7.28199 15.471C7.31568 15.5804 7.37397 15.6807 7.45241 15.7641C7.53084 15.8475 7.62733 15.9119 7.73448 15.9522C7.84163 15.9926 7.9566 16.0078 8.07057 15.9969C8.18454 15.9859 8.29449 15.949 8.39199 15.889L11.166 14.182C11.4205 14.0254 11.6307 13.8063 11.7765 13.5455C11.9223 13.2846 11.9989 12.9908 11.999 12.692V9.485C12.337 9.197 12.664 8.895 12.978 8.581L13.436 8.122C15.0771 6.48154 15.9994 4.2564 16 1.936V1.75C16 1.28587 15.8156 0.840752 15.4874 0.512563C15.1592 0.184374 14.7141 0 14.25 0H14.064ZM10.5 10.625C10.412 10.685 10.323 10.743 10.234 10.8L7.88399 12.321L8.43199 14.104L10.381 12.904C10.4174 12.8816 10.4474 12.8503 10.4682 12.813C10.4891 12.7757 10.5 12.7337 10.5 12.691V10.625ZM3.67799 8.116L5.19999 5.766C5.25799 5.676 5.31699 5.588 5.37599 5.5H3.30899C3.26628 5.49999 3.22427 5.51092 3.18699 5.53175C3.1497 5.55258 3.11837 5.58262 3.09599 5.619L1.89599 7.569L3.67799 8.116ZM8.93799 3.623C10.2973 2.26391 12.1408 1.50028 14.063 1.5H14.249C14.3153 1.5 14.3789 1.52634 14.4258 1.57322C14.4727 1.62011 14.499 1.6837 14.499 1.75V1.936C14.4991 2.88813 14.3117 3.83096 13.9474 4.71066C13.5832 5.59035 13.0492 6.38968 12.376 7.063L11.917 7.521C11.157 8.281 10.32 8.958 9.41799 9.541L7.10099 11.041L4.95799 8.898L6.45799 6.581C7.04138 5.67884 7.71847 4.84085 8.47799 4.081L8.93599 3.623H8.93799ZM12 5C12 5.26522 11.8946 5.51957 11.7071 5.70711C11.5196 5.89464 11.2652 6 11 6C10.7348 6 10.4804 5.89464 10.2929 5.70711C10.1053 5.51957 9.99999 5.26522 9.99999 5C9.99999 4.73478 10.1053 4.48043 10.2929 4.29289C10.4804 4.10536 10.7348 4 11 4C11.2652 4 11.5196 4.10536 11.7071 4.29289C11.8946 4.48043 12 4.73478 12 5ZM3.55999 14.56C3.70736 14.4227 3.82557 14.2571 3.90755 14.0731C3.98954 13.8891 4.03362 13.6905 4.03717 13.489C4.04073 13.2876 4.00368 13.0876 3.92824 12.9008C3.85279 12.714 3.7405 12.5444 3.59807 12.4019C3.45563 12.2595 3.28596 12.1472 3.09919 12.0718C2.91241 11.9963 2.71235 11.9593 2.51095 11.9628C2.30954 11.9664 2.11091 12.0105 1.92691 12.0924C1.74292 12.1744 1.57731 12.2926 1.43999 12.44C0.70599 13.17 0.39299 14.772 0.28999 15.443C0.2839 15.4792 0.286547 15.5163 0.29771 15.5512C0.308873 15.5861 0.328229 15.6179 0.354162 15.6438C0.380096 15.6698 0.411855 15.6891 0.44679 15.7003C0.481726 15.7114 0.518824 15.7141 0.55499 15.708C1.22599 15.605 2.82799 15.292 3.55999 14.56Z" fill="#2d6cdf"></path>
                      </svg>
                    </div>
                    <span>Faltam para o próximo benefício:</span>
                  </div>
                  <span id="valor">${faltamParaProximo ?? 0}</span>
                </div>`
            }
              <div class="font-14 font-500 gap-4 resumo-cliente-item u-flex-center utilizados">
                <div class="resumo-cliente-item-descricao u-flex-center gap-4">
                  <div class="svg-icon">
                    <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.75 1.5C4.05964 1.5 3.5 2.05964 3.5 2.75C3.5 3.44036 4.05964 4 4.75 4H7.05874C6.82579 3.18244 6.51662 2.59892 6.18056 2.20684C5.75052 1.70513 5.26611 1.5 4.75 1.5ZM2 2.75C2 3.20011 2.10814 3.62497 2.29985 4H1.75C0.783502 4 0 4.7835 0 5.75V7.75C0 8.4481 0.408763 9.05073 1 9.33159V14.25C1 15.2165 1.7835 16 2.75 16H13.25C14.2165 16 15 15.2165 15 14.25V9.33159C15.5912 9.05073 16 8.4481 16 7.75V5.75C16 4.7835 15.2165 4 14.25 4H13.7001C13.8919 3.62497 14 3.20011 14 2.75C14 1.23122 12.7688 0 11.25 0C10.2661 0 9.37552 0.419865 8.68056 1.23066C8.42475 1.5291 8.19773 1.87723 8 2.27304C7.80227 1.87723 7.57525 1.5291 7.31944 1.23066C6.62448 0.419865 5.73389 0 4.75 0C3.23122 0 2 1.23122 2 2.75ZM8.94127 4H11.25C11.9404 4 12.5 3.44036 12.5 2.75C12.5 2.05964 11.9404 1.5 11.25 1.5C10.7339 1.5 10.2495 1.70513 9.81944 2.20684C9.48338 2.59892 9.17421 3.18244 8.94127 4ZM1.75 5.5C1.61193 5.5 1.5 5.61193 1.5 5.75V7.75C1.5 7.88807 1.61193 8 1.75 8H7.25V5.5H1.75ZM8.75 5.5V8H14.25C14.3881 8 14.5 7.88807 14.5 7.75V5.75C14.5 5.61193 14.3881 5.5 14.25 5.5H8.75ZM8.75 9.5H13.5V14.25C13.5 14.3881 13.3881 14.5 13.25 14.5H8.75V9.5ZM7.25 9.5V14.5H2.75C2.61193 14.5 2.5 14.3881 2.5 14.25V9.5H7.25Z" fill="#ff304f"></path>
                    </svg>
                  </div>
                  <span>Pontos já utilizados:</span>
                </div>
                <span id="valor">${cliente.pontosUtilizados ?? 0}</span>
              </div>
            </div>
            <div class="resgate-beneficios">
              ${beneficiosProd?.length > 0 ?
              `<div class="beneficios-cadastrados flex-column gap-6">
                    <h4 style="color: #3d3d3d; margin-bottom: 8px;">Selecione um benefício</h4>
                    <div class="input-wrapper">
                      <select id="beneficiosCadastrados">
                          <option value="0">Selecione</option>
                          ${beneficiosProd.map((beneficio) => {

                if (!clientePrimeiroPedido && beneficio.Pontos == 0) {
                  return ''
                }

                return `<option value="${beneficio.BeneficioFidelidade?.Id}" produto="${beneficio.Produto}"pontos="${beneficio.Pontos}">
                                    ${beneficio.BeneficioFidelidade?.Descricao}
                                    (${beneficio.Pontos} pontos)
                                  </option>`
              }).join('')}
                      </select>
                    </div>
                  </div>` :
              `<div class="sem-beneficios">Nenhum benefício cadastrado</div>`}
            </div>
            <div class="confirma-resgate">
              <button id="confirmar-button" class="btn btn-azul">Resgatar benefício</button>
            </div>
          `,
          bodyClassList: 'u-p-16 page-fideliza'
        })

        const btnResgate = select('.confirma-resgate #confirmar-button')
        btnResgate && btnResgate.addEventListener('click', () => {
          const beneficioSelecionado = select('#beneficiosCadastrados')
          const pontosUtilizados = beneficioSelecionado.options[beneficioSelecionado.selectedIndex]?.getAttribute('pontos')?.parseNumber();
          const idProduto = beneficioSelecionado.options[beneficioSelecionado.selectedIndex]?.getAttribute('produto')?.parseNumber();
          const nomeProduto = beneficioSelecionado.options[beneficioSelecionado.selectedIndex].text;

          if (beneficioSelecionado && beneficioSelecionado.value.parseNumber() === 0) {
            toastFideliza('Selecione um benefício.')
            return
          }

          if (cliente.pontos < pontosUtilizados) {
            toastFideliza('Você não possui pontos suficientes para resgatar este benefício.')
            return
          }

          resgatarBeneficio(pontosUtilizados, idProduto, nomeProduto, beneficios)
        })

        mensagemFidelidade()
      },
      error: () => {
        gif.end()
      }
    })
  }
}

window.personalizaPizzaFideliza = false;

export function resgatarBeneficio(pontos, idProduto, nomeProduto, beneficios) {

  //Se não tem produto e nem pontos, não faz nada
  if (!idProduto || !pontos) {
    toastFideliza('Selecione um benefício.')
    return
  }

  //Encontro o produto
  const produtoSelecionado = store.produtos.find((produto) => produto.IdClassProduto === idProduto)

  if (!produtoSelecionado) {
    toastFideliza('Este benefício não está disponível para resgate, verifique com o estabelecimento.')
    return
  }

  //Verifico se o produto já está no carrinho
  const produtoJaAdicionado = storeOrder.Itens.find((item) => item.idProduto === produtoSelecionado.IdProd)
  if (produtoJaAdicionado) {
    toastFideliza('Este benefício já está no seu pedido.')
    return
  }

  //Verifico se o produto é uma pizza para abrir a personalização da mesma
  const isPizza = storePizzas && storePizzas.find(pz => pz.Id == produtoSelecionado.IdProd);
  if (isPizza) {
    const buttons = [
      {
        content: "Cancelar",
        class: 'btn-transparent flex-1',
        callback: (dialog) => {
          dialog.remove()
          personalizaPizzaFideliza = false;
        }
      },
      {
        content: "Personalizar",
        class: 'btn-azul flex-1',
        callback: (wrapper) => {
          //Fecho o MessageBox
          wrapper.remove()

          //Fecha a página do programa de Fidelidade
          $('#programa-de-fidelidade .app-bar img').click()
          $('.menu-background').click()

          //Abre a personalização da pizza
          const itemPizza = select('.cardapio-container .produto[idprod="' + produtoSelecionado.IdProd + '"]')
          itemPizza && itemPizza.click()

          personalizaPizzaFideliza = true;

          //Exibo a mensagem ao usuário
          toastFideliza('Personalize sua pizza antes de concluir o resgate dela, não se preocupe, o valor dela será zerado! (caso não tenha adicionais na pizza)', 5000)
        }
      },
    ]

    createMessageBox({
      class: 'dialog-no-padding dialog-adicionais-sabores',
      content: `
      <div class="flex flex-column">
        <div class="font-14 font-700 p-12">Deseja personalizar os sabores da sua pizza?</div>  
      </div>`,
      closeOnClickOutside: false,
      buttons
    })

  } else {
    continuaResgate()
  }

  function continuaResgate() {
    //Gero o ticks para o calculo do CodTicks C#
    const ticks = new Date().getTime()

    //Adiciono o produto ao carrinho
    storeOrder.Itens.push({
      Adicionais: [],
      CodProduto: produtoSelecionado.IdProd,
      CodTicks: (ticks * 10000 + 621355968000000000).toString(),
      Observacao: "",
      PrecoDelivery: 0,
      Produto_Produto: produtoSelecionado.NomeDelivery,
      Quantidade: 1,
      QuantidadeAPagar: 1,
      Sabores: [],
      ValorAPagar: 0,
      ValorComAdicionais: 0,
      ValorTotal: 0,
      ValorUnitario: 0,
      idProduto: produtoSelecionado.IdProd,
      isAgrupamento: false,
      IsItemFidelidade: true
    })

    storeOrder.PontosUtilizados = pontos ?? 0

    storeOrder.Itens.sort((itemA, itemB) => itemA.CodTicks - itemB.CodTicks)

    storeOrder.valorTotal = 0
    storeOrder.Itens.forEach((item) => {
      storeOrder.valorTotal += item.ValorTotal
    })

    //Fecha a página do programa de Fidelidade
    $('#programa-de-fidelidade .app-bar img').click()
    $('.menu-background').click()

    //Exibe o botão para ver o pedido
    showButtonOrder()

    //Adiciono o pedido na localStorage
    storage.set(`pedido-mobile-${estabelecimento.urlEmpresa}`, storeOrder)

    //Exibo a mensagem ao usuário
    toastFideliza('Benefício resgatado e inserido no seu pedido!')
  }
}

export function configuraProgramaFidelidade() {
  if (!estabelecimento.qrCode.ativo) {
    axios
      .get(getUrlAction('Cadastros', 'GetDadosProgramaFidelidade'), {
        params: {
          urlEmpresa: estabelecimento.urlEmpresa,
        }
      })
      .then(({ data }) => {
        if (data.valido) {
          estabelecimento.programaFidelidade = data

          if (estabelecimento.programaFidelidade) {
            estabelecimento.programaFidelidade.cliente = {
              pontos: estabelecimento.programaFidelidade.pontosAtuaisFideliza,
              pontosUtilizados: estabelecimento.programaFidelidade.pontosUtilizadosFideliza
            }
          }

          if (estabelecimento.programaFidelidade.Ativo) {
            const elementoMenu = select('#menu-fidelidade')
            if (elementoMenu && elementoMenu.style.display === 'none') {
              elementoMenu.style.display = ''
              elementoMenu.addEventListener('click', () => {
                programaDeFidelidade()
              })
            }
          }
        }
      })
      .catch((error) => {
        sentryError.exception(error)
      })
  }
}